import { OrderStatus } from "@/api/api-client"

export type OrderStatusLabels = Partial<Record<OrderStatus, string>>

export interface OrderStatusPresentation {
  stepIndex: number
  label: string
  badgeClassName: string
}

const STATUS_BADGE_CLASSES: Record<OrderStatus, string> = {
  [OrderStatus.Pending]: "bg-amber-100 text-amber-800 border-amber-200",
  [OrderStatus.StockVerified]: "bg-blue-100 text-blue-800 border-blue-200",
  [OrderStatus.ShippingQuoted]: "bg-violet-100 text-violet-800 border-violet-200",
  [OrderStatus.PaymentReceived]: "bg-indigo-100 text-indigo-800 border-indigo-200",
  [OrderStatus.OrderShipped]: "bg-teal-100 text-teal-800 border-teal-200",
  [OrderStatus.ReadyForPickup]: "bg-cyan-100 text-cyan-800 border-cyan-200",
  [OrderStatus.OrderComplete]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [OrderStatus.OrderDeclined]: "bg-red-100 text-red-800 border-red-200",
}

const STATUS_STEP_INDEX: Record<OrderStatus, number> = {
  [OrderStatus.Pending]: 0,
  [OrderStatus.StockVerified]: 1,
  [OrderStatus.ShippingQuoted]: 2,
  [OrderStatus.PaymentReceived]: 3,
  [OrderStatus.OrderShipped]: 4,
  [OrderStatus.ReadyForPickup]: 4,
  [OrderStatus.OrderComplete]: 5,
  [OrderStatus.OrderDeclined]: -1,
}

export function getOrderStatusPresentation(
  status: OrderStatus,
  labels: OrderStatusLabels = {}
): OrderStatusPresentation {
  return {
    stepIndex: STATUS_STEP_INDEX[status] ?? 0,
    label: labels[status] ?? status,
    badgeClassName: STATUS_BADGE_CLASSES[status] ?? STATUS_BADGE_CLASSES[OrderStatus.Pending],
  }
}
